export enum PopType {
  textbox = 0,
  pencilBrush = 1,
  shape = 2,
  background = 3,
}
